import { atom } from 'jotai';
import { $CurrentGalleryArticle } from './current-gallery-article';
import _clamp from 'lodash/clamp';

export enum EArticleGalleryLayoutStrategy {
  SQUARE,
  RECTANGLE,
}

export const $LayoutStrategy = atom<EArticleGalleryLayoutStrategy>(EArticleGalleryLayoutStrategy.SQUARE);

export const $RootPaddingBottom = atom<number>((get) => {
  const layoutStrategy = get($LayoutStrategy);

  if (layoutStrategy === EArticleGalleryLayoutStrategy.SQUARE) {
    return 100;
  }

  const { imageList } = get($CurrentGalleryArticle);
  const firstImage = imageList[0];
  if (!firstImage) {
    return 100;
  }

  return 100 * _clamp(firstImage.height / firstImage.width, 3 / 4, 4 / 3);
});
